import axios from "axios";

import {
  ADD_CONTACTO,
  UPLOADING_FILE,
  UPDATE_PROGRESS,
  GET_ERRORS,
  ADD_LEAD,
  GET_BUSQUEDA,
  GET_CAPITULOS,
  GET_SECCIONES,
  GET_FRACCIONES,
  GET_SUBPARTIDAS,
  GET_PARTIDAS,
  GET_NICOS,
  GET_NOTAS,
  GET_DESCRIPCION,
  GET_HISTORICO,
  GET_TLCS,
  GET_ALADIS,
  GET_FRANJA,
  GET_PROHIBICIONES,
  GET_INDICADORES,
  GET_ARANCEL_PAIS,
  GET_PERMISOS,
  GET_NOMS,
  GET_CUOTAS_COMPENSATORIAS,
  GET_IMMEX,
  GET_PROMOCION_SECTORIAL,
  GET_PRECIOS_ESTIMADOS,
  GET_ARANCEL_CUPO,
  GET_IVA,
  GET_ISAN,
  GET_IEPS,
  GET_PACIC,
  GET_MERCANCIA_PELIGROSA,
  GET_CONTROL_DE_EXPORTACIONES,
  GET_MEDIDAS_DE_TRANSICION,
  GET_DEPOSITO_FISCAL,
  GET_MERCANCIAS_VULNERABLES,
  GET_VEHICULOS_USADOS,
  GET_MARCAS_COMERCIALES,
  GET_ANEXO_7,
  GET_ANEXO_8,
  GET_ANEXO_9,
  GET_ANEXO_29,
  GET_ANEXO_10,
  GET_ANEXO_12,
  GET_ANEXO_14,
  GET_ANEXO_17,
  GET_ANEXO_21,
  GET_ANEXO_28,
  GET_ANEXO_21_DOS,
  GET_ANEXO_21_TRES,
  GET_ISAN_DOS,
  GET_PRECIOS_ESTIMADOS_DOS,
  GET_PRECIOS_ESTIMADOS_TRES,
  GET_CUPOS_TLC,
  GET_NOTAS_TLC,
  GET_CUPOS_ALADIS_UNO,
  GET_CUPOS_ALADIS_DOS,
  GET_CORRELATIVO,
  GET_INDICADORES_MANANA,
} from "./types";

export const addContacto = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/travel/contacto", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: ADD_CONTACTO,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const addLead = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/travel/lead", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: ADD_LEAD,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const reiniciaBusqueda = (Data) => (dispatch) => {
  dispatch({
    type: GET_BUSQUEDA,
    payload: [],
  });
};

export const getBusqueda = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/busqueda", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_BUSQUEDA,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getSecciones = () => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .get("/api/tarifa/getSecciones", {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_SECCIONES,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getCapitulos = () => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .get("/api/tarifa/getCapitulos", {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_CAPITULOS,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getPartida = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getPartida", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PARTIDAS,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getSubpartida = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getSubpartida", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_SUBPARTIDAS,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getFraccion = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getFraccion", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_FRACCIONES,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getNicos = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getNicos", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_NICOS,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getNotas = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getNotas", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_NOTAS,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getDescripcion = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getDescripcion", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_DESCRIPCION,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getHistorico = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getHistorico", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_HISTORICO,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getTLCs = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getTLCs", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_TLCS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getALADIs = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getALADIs", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ALADIS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getFranja = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getFranja", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_FRANJA,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getProhibiciones = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getProhibiciones", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PROHIBICIONES,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getIndicadores = (Data) => async (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  fetch(
    `https://sidofqa.segob.gob.mx/dof/sidof/indicadores/${Data ? Data : ""}`,
    {
      method: "GET",
    }
  )
    .then((response) => response.json())
    .then((data) => {
      dispatch({
        type: GET_INDICADORES,
        payload: data.ListaIndicadores,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getIndicadoresDos = (Data) => async (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  fetch(
    `https://sidofqa.segob.gob.mx/dof/sidof/indicadores/${Data ? Data : ""}`,
    {
      method: "GET",
    }
  )
    .then((response) => response.json())
    .then((data) => {
      dispatch({
        type: GET_INDICADORES_MANANA,
        payload: data.ListaIndicadores,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getArancelPais = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getArancelPais", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ARANCEL_PAIS,
        payload: result.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};
export const getPermisos = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getPermisos", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PERMISOS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getNoms = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getNoms", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_NOMS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getCuotasCompensatorias = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getCuotasCompensatorias", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_CUOTAS_COMPENSATORIAS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getImmex = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getImmex", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_IMMEX,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getPromocionSectorial = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getPromocionSectorial", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PROMOCION_SECTORIAL,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getPreciosEstimados = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getPreciosEstimados", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PRECIOS_ESTIMADOS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getArancelCupo = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getArancelCupo", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ARANCEL_CUPO,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getIva = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getIva", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_IVA,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getIsan = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getIsan", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ISAN,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getIeps = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getIeps", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_IEPS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const getPacic = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getPacic", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PACIC,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const get_mercancia_peligrosa = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_mercancia_peligrosa", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_MERCANCIA_PELIGROSA,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_control_de_exportaciones = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_control_de_exportaciones", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_CONTROL_DE_EXPORTACIONES,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_medidas_de_transicion = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_medidas_de_transicion", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_MEDIDAS_DE_TRANSICION,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_deposito_fiscal = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_deposito_fiscal", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_DEPOSITO_FISCAL,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_mercancias_vulnerables = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_mercancias_vulnerables", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_MERCANCIAS_VULNERABLES,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_vehiculos_usados = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_vehiculos_usados", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_VEHICULOS_USADOS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_marcas_comerciales = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_marcas_comerciales", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_MARCAS_COMERCIALES,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_7 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_7", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_7,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_8 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_8", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_8,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_9 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_9", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_9,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_29 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_29", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_29,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_10 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_10", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_10,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_12 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_12", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_12,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_14 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_14", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_14,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_17 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_17", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_17,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_21 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_21", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_21,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
export const get_anexo_28 = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_28", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_28,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const get_anexo_21_dos = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_21_dos", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_21_DOS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const get_anexo_21_tres = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/get_anexo_21_tres", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ANEXO_21_TRES,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getIsanDos = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getIsanDos", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_ISAN_DOS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getPreciosEstimadosDos = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getPreciosEstimadosDos", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PRECIOS_ESTIMADOS_DOS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getPreciosEstimadosTres = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/getPreciosEstimadosTres", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_PRECIOS_ESTIMADOS_TRES,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getCuposTLC = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  dispatch({
    type: GET_CUPOS_TLC,
    payload: [],
  });

  axios
    .post("/api/tarifa/get_cupos_tlc", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_CUPOS_TLC,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getNotasTLC = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  dispatch({
    type: GET_NOTAS_TLC,
    payload: [],
  });

  axios
    .post("/api/tarifa/get_notas_tlc", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_NOTAS_TLC,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getCuposALADIUno = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  dispatch({
    type: GET_CUPOS_ALADIS_UNO,
    payload: [],
  });

  axios
    .post("/api/tarifa/get_cupos_aladis_uno", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_CUPOS_ALADIS_UNO,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getCuposALADIDos = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  dispatch({
    type: GET_CUPOS_ALADIS_DOS,
    payload: [],
  });

  axios
    .post("/api/tarifa/get_cupos_aladis_dos", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_CUPOS_ALADIS_DOS,
        payload: result.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};

export const getCorrelativo = (Data) => (dispatch) => {
  dispatch({
    type: UPLOADING_FILE,
  });

  axios
    .post("/api/tarifa/busqueda", Data, {
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader("content-length") ||
            progressEvent.target.getResponseHeader(
              "x-decompressed-content-length"
            );

        if (totalLength !== null) {
          dispatch({
            type: UPDATE_PROGRESS,
            payload: Math.round((progressEvent.loaded * 100) / totalLength),
          });
        }
      },
    })
    .then((result) => {
      dispatch({
        type: GET_CORRELATIVO,
        payload: result.data,
      });
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err,
      })
    );
};
